export type MigrationSource = 'hootsuite'

export const SOURCE_LABELS: Record<MigrationSource, string> = {
  hootsuite: 'Hootsuite',
}

export type WizardStep = 'upload' | 'channel-mapping' | 'review' | 'importing'

export type ImportItemStatus =
  | 'valid'
  | 'error'
  | 'skipped'
  | 'importing'
  | 'success'
  | 'failed'

export type ImportItemChannel = {
  sourcePlatform: string
  sourceAccountName: string
  mappedChannelId?: string
}

export type ImportItemMedia = {
  type: 'image' | 'video'
  url: string
  altText?: string
}

export type ImportItemPost = {
  text: string
  scheduledTime?: Date
  originalStatus: 'draft' | 'scheduled' | 'sent' | 'unknown'
  media?: ImportItemMedia
  tags?: string[]
  linkToPublishedPost?: string
}

export type ImportItem = {
  id: string
  sourceRow: number
  status: ImportItemStatus
  errors: string[]
  channel: ImportItemChannel
  post: ImportItemPost
}

export type ChannelMapping = {
  sourceKey: string
  sourcePlatform: string
  sourceAccountName: string
  mappedChannelId: string | null
  postCount: number
}

export type ImportSession = {
  id: string
  source: MigrationSource
  startedAt: string
  timezone: string
  channelMappings: ChannelMapping[]
  items: SerializedImportItem[]
  step: WizardStep
}

/**
 * Serialized version of ImportItem where Date fields are stored as ISO strings
 * for JSON compatibility in localStorage.
 */
export type SerializedImportItem = Omit<ImportItem, 'post'> & {
  post: Omit<ImportItemPost, 'scheduledTime'> & {
    scheduledTime?: string
  }
}
